import axios from '@/axios/axios2'

// 获取个人业绩日维度
export const getgryjday = params => axios.post('/app/getgryjday', params)

// 获取个人业绩月维度
export const getgryjmonth = params => axios.post('/app/getgryjmonth', params)

//-----------------------------改版后↓---------------------------------------
// 获取个人业绩日维度
export const getDataSelfDay = params =>
  axios.post('/statistics/getDataSelfDay', params)

// 获取个人业绩月维度
export const getDataSelfMonth = params =>
  axios.post('/statistics/getDataSelfMonth', params)

// 查询累计商户数
export const getCumulative = params =>
  axios.post('/statistics/getCumulative', params)
